import React from 'react'
import IconButton from '@mui/material/IconButton'
import { BookmarkAdd, BookmarkAdded } from '@mui/icons-material'
import Tooltip from '@mui/material/Tooltip'
import { Button } from '@mui/material'
import BookmarkRemoveIcon from '@mui/icons-material/BookmarkRemove'
import useFavoriteBacktest from '../../hooks/useFavoriteBacktest'

interface FavoriteBacktestIconButtonProps {
  onClick?: () => void
  backtest: any
  [x: string]: any
}

function FavoriteBacktestIconButton({
  onClick,
  backtest,
  asButton,
  bookmarkRemoveAsChecked,
  ...otherProps
}: FavoriteBacktestIconButtonProps) {
  const { isFavorited, toggleFavorite } = useFavoriteBacktest(backtest)

  const handleClick = async (event: React.MouseEvent) => {
    event.stopPropagation()
    await toggleFavorite()
    if (onClick) {
      onClick()
    }
  }

  const iconButton = (
    <Tooltip title={isFavorited ? 'Remove from Favorites' : 'Add to Favorites'} placement="top">
      <IconButton
        onClick={handleClick}
        sx={{ color: isFavorited ? 'primary.main' : 'inherit' }}
        {...otherProps}
      >
        {isFavorited ? (
          bookmarkRemoveAsChecked ? (
            <BookmarkAdded fontSize={otherProps.size || 'medium'} />
          ) : (
            <BookmarkRemoveIcon fontSize={otherProps.size || 'medium'} />
          )
        ) : (
          <BookmarkAdd fontSize={otherProps.size || 'medium'} />
        )}
      </IconButton>
    </Tooltip>
  )

  const button = (
    <Button
      onClick={handleClick}
      fullWidth
      endIcon={
        isFavorited ? (
          bookmarkRemoveAsChecked ? (
            <BookmarkAdded fontSize={otherProps.size || 'medium'} />
          ) : (
            <BookmarkRemoveIcon fontSize={otherProps.size || 'medium'} />
          )
        ) : (
          <BookmarkAdd fontSize={otherProps.size || 'medium'} />
        )
      }
    >
      {isFavorited ? 'Remove from Favorites' : 'Add to Favorites'}
    </Button>
  )

  return asButton ? button : iconButton
}

export default FavoriteBacktestIconButton
